module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/keepCoolNoPPAPresents.fr_CA-c5434e3f5c25d978c579d5cdc388b3d8.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/keepCoolNoPPAPresents.fr_CA.png
// module id = 2452
// module chunks = 2